module.exports = "/images/mara-av.png?4a9c43ac81ad2645e715fd2ac4a95e9f";